import React, {useEffect} from "react";
import {Breadcrumbs} from "@mui/material";
import classNames from "classnames";
import {useCategory} from "@/features/article/model/useCategory";
import {usePagination} from "@/features/article/model/usePagination";
import {formatDMY} from "@/shared/lib/date";
import {useArticleStore} from "@/Stores/Site/Article";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import {lazyWithPreload} from "@/Helpers/lazyWithPreload";
import LazySection from "@/Components/LazySection";
import "@/Scss/Site/Blog/index.scss";

const Pagination = lazyWithPreload(() => import('@/Components/Site/Pagination'));

const Index = (props) => {
    const {blogData = [], isMobile = false} = props;
    const {articles = [], categories = [], categoryId = 1, countArticles = 0, page = 1, perPageStart = 12} = blogData;

    const initData = useArticleStore(state => state.initData);

    const {changeCategory} = useCategory({
        source: 'blog',
        categoryId
    });
    const {changePage} = usePagination({
        source: 'blog',
        categoryId,
        page,
        perPage: perPageStart
    });

    useEffect(() => {
        initData(blogData);
    }, [categoryId, page]);

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                <div className={`container`}>
                    <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                        <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                        <p className={`breadcrumbs__text`}>Блог</p>
                    </Breadcrumbs>
                    <h1 className={`h1`}>Блог</h1>
                    <div className={`blogPage`}>
                        <div className={`blogPage__navigations`}>
                            {categories.map((el) => {
                                return (
                                    <p
                                        key={el.id}
                                        className={classNames('blogPage__navigationItem', {'blogPage__navigationItem--active': el.id === categoryId})}
                                        onClick={() => changeCategory(el.id)}
                                    >
                                        {el.category}
                                    </p>
                                );
                            })}
                        </div>
                        <div className={`blogPage__articles`}>
                            {articles.length === 0 && (
                                <p className={`blogPage__noArticles`}>В данной категории отсутствуют статьи.</p>
                            )}
                            {articles.length > 0 && (
                                <>
                                    {articles.map((el) => {
                                        return (
                                            <Link
                                                href={`/blog/${el.url}`} key={el.id}
                                                className={`blogPage__articleItem`}
                                            >
                                                <Picture
                                                    src={el.imgPreview}
                                                    alt={el.h1}
                                                    title={el.h1}
                                                    imageClassName={`increase`}
                                                />
                                                <div className={`blogPage__articleItemContent`}>
                                                    <p className={`blogPage__articleItemCategory`}>{el.category}</p>
                                                    <p className={`blogPage__articleItemTitle`}>{el.h1}</p>
                                                    <p className={`blogPage__articleItemDate`}>
                                                        {formatDMY(el.published_at)}
                                                    </p>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                        <LazySection>
                            <Pagination
                                activePage={page}
                                itemsCountPerPage={perPageStart}
                                totalItemsCount={countArticles}
                                pageRangeDisplayed={isMobile ? 3 : 10}
                                onChange={changePage}
                                hideFirstLastPages={isMobile}
                            />
                        </LazySection>
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
};

export default Index;
